export default "__VITE_ASSET__ZOZLizZF__"